// extracted by mini-css-extract-plugin
module.exports = {"keyboardShortcut":"KeyboardShortcut_keyboardShortcut__P963K","startIcon":"KeyboardShortcut_startIcon__i9wMV"};